import * as React from 'react';

interface Props {
  content: string | React.JSX.Element;
}

const SearchInfo: React.FC<Props> = (props) => {
  let jsxContent = props.content as React.JSX.Element;
  if (jsxContent == null) {
    jsxContent = <span>props.message</span>;
  }

  return (
    <div className="search-info">
      <i className="fa-solid fa-fw fa-circle-info"></i>
      <span>{jsxContent}</span>
    </div>
  );
};

export default SearchInfo;
